import { dealerdataLogServices } from '../services';
import { dealerdataLogConstants } from '../constants';
import { alertActions } from '.';

export const dealerdataActions = {
  getAll,
  loadingData,
  exportData,
  getStateDDL,
  getCityDDL
};

function getStateDDL(data) {
  return (dispatch) => {
    dispatch(request());

    dealerdataLogServices.fetchStateDLL(data).then(
      (response) => {
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  }; function request() {
    return { type: dealerdataLogConstants.GETSTATEDDL_REQUEST };
  }
  function success(datas) {
    return { type: dealerdataLogConstants.GETSTATEDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: dealerdataLogConstants.GETSTATEDDL_FAILURE, error };
  }
}
function getCityDDL(data) {
  return (dispatch) => {
    dispatch(request());

    dealerdataLogServices.fetchCityDLL(data).then(
      (response) => {
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: dealerdataLogConstants.GETSCITYDDL_REQUEST };
  }
  function success(datas) {
    return { type: dealerdataLogConstants.GETSCITYDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: dealerdataLogConstants.GETSCITYDDL_FAILURE, error };
  }
}

function getAll(obj) {
  debugger
  return dispatch => {
    dispatch(request());
    dealerdataLogServices.fetchdealerdataData(obj).then(response => {
      dispatch(loadingData(false));
      dispatch(success(response.ResponseData))

      var data = response.ResponseData;
      if (data != null) {
        data.forEach(function (v) {
          delete v.TotalRows;
          delete v.AadharImage;
          delete v.AadharNo;
          delete v.ProductId;
          delete v.ProductName;
          delete v.QrData;
          delete v.VerificationMode;
          delete v.VerifiedBy;
          delete v.RoleName;
          delete v.StatusResult;
        });
      }
      dispatch(successExport(data))
    },
      error => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }

    );
  };
  function request() { return { type: dealerdataLogConstants.GETALL_REQUEST } }
  function success(datas) { return { type: dealerdataLogConstants.GETALL_SUCCESS, datas } }
  function successExport(datas) { return { type: dealerdataLogConstants.GETEXPORT_SUCCESS, datas } }
  function failure(error) { return { type: dealerdataLogConstants.GETALL_FAILURE, error } }
}

function exportData(obj) {
  return dispatch => {
    dispatch(request());
    dealerdataLogServices.fetchdealerdataData(obj).then(response => {
      debugger
      dispatch(loadingData(false));
      var data = response.ResponseData;
      if (data != null) {
        data.forEach(function (v) {
          delete v.TotalRows;
          delete v.AadharImage;
          delete v.AadharNo;
          delete v.ProductId;
          delete v.ProductName;
          delete v.QrData;
          delete v.VerificationMode;
          delete v.VerifiedBy;
          delete v.RoleName;
          delete v.StatusResult;
        });
      }
      dispatch(success(data))
    },
      error => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      });
  };
  function request() { return { type: dealerdataLogConstants.GETEXPORT_REQUEST } }
  function success(datas) { return { type: dealerdataLogConstants.GETEXPORT_SUCCESS, datas } }
  function failure(error) { return { type: dealerdataLogConstants.GETEXPORT_FAILURE, error } }
}

function loadingData(isbool) {
  return {
    type: dealerdataLogConstants.LOADING_REQUEST, isbool
  }
}
